import React from 'react';
import Image from 'ls-common-client/dist/components/Image';
import NextLink from '../../NextLink';
import { LocalsearchBasic } from '../../../assets/localsearchLogo';

const Logo = () => {
  return (
    <NextLink to="/" aria-label="back to home">
      <Image src={LocalsearchBasic} width="123px" />
    </NextLink>
  );
};

export default Logo;
